import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { SITE } from "@/config/site";
import { ChapterHeading } from "@/components/ChapterHeading";
import { Reveal } from "@/components/Reveal";
import { trackEvent } from "@/lib/analytics";

export function Faq() {
  const onOpen = (value) => {
    if (!value) return;
    const idx = Number(value.split("-")[1]);
    const question = SITE.faqs[idx] && SITE.faqs[idx].q;
    trackEvent("faq_interaction", { question: question || value });
  };

  return (
    <section id="faq" data-testid="faq-section" className="relative px-5 py-20 sm:px-8 sm:py-28 lg:py-36">
      <div className="mx-auto max-w-4xl">
        <ChapterHeading number="10" title="Questions" urdu="سوالات" testId="faq-heading" />
        <Reveal delay={0.1} className="mt-12">
          <Accordion type="single" collapsible className="w-full" onValueChange={onOpen}>
            {SITE.faqs.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`faq-${i}`}
                className="border-[#D4AF37]/15"
                data-testid={`faq-item-${i + 1}`}
              >
                <AccordionTrigger
                  data-testid={`faq-question-${i + 1}`}
                  className="py-6 text-left text-lg text-[#F7F4EF] transition-colors hover:text-[#E6CA65] hover:no-underline sm:text-xl [&[data-state=open]]:text-[#E6CA65]"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-answer-${i + 1}`}
                  className="text-base leading-[1.8] text-[#C8C2B7] sm:text-lg"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
